import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export const modalXPadding = '1.5rem'

export const HeaderStyled = styled.header({
  padding: `1rem ${modalXPadding}`,
  backgroundColor: hexColors.blueDiamond,
  color: hexColors.white,
  fontSize: '1.2rem',
})

export const QuickbetBodyStyled = styled.div({
  padding: `1.5rem ${modalXPadding} 0rem ${modalXPadding}`,
  background: hexColors.whiteSmoke,
  minHeight: '13rem',
  overflow: 'auto',
})

export const QuickbetActionsStyled = styled.footer({
  boxSizing: 'border-box',
  position: 'relative',
  width: '100%',
  padding: modalXPadding,
})
